<template>
  <vs-dropdown-item
    :to="`/contracts`"
    class="flex justify-between py-4 notification cursor-pointer"
  >
    <relative-time-notification />

    <div class="flex items-start">
      <div class="mx-2">
        <span
          class="font-medium block notification-title"
          :class="[`text-primary`]"
          >Contract veranderen</span
        >
        <small>{{ $t("Action.May") }}</small>
      </div>
    </div>
  </vs-dropdown-item>
</template>
<script>
import RelativeTimeNotification from "./RelativeTimeNotification.vue";
export default {
  components: { RelativeTimeNotification },
  props: ["action"],
};
</script>
